import { useEffect, useRef, useState } from "react";
import { LegalComponent } from "../pages/legal/components/LegalComponent";
import { TermsData } from "../pages/legal/data/TermsData";
import { Modal } from "react-bootstrap-v5";
import { KTSVG } from "../../_metronic/helpers";

type Props = {
    show: boolean;
    confirm?: () => void;
    noConfirm?: () => void;
};

const ConfirmTermsConditions = ({ show, confirm, noConfirm }: Props) => {
    const scrollContainer = useRef<HTMLDivElement>(null);
    const [canAccept, setCanAccept] = useState(false);

    useEffect(() => {
        if (!show) return;

        const el = scrollContainer.current;
        if (!el) return;

        // Reset estado cada vez que se abre
        setCanAccept(false);

        const onScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = el;
            const bottomReached = scrollTop + clientHeight >= scrollHeight - 5;
            setCanAccept(bottomReached);
        };

        // Caso: no hay scroll (contenido corto)
        if (el.scrollHeight <= el.clientHeight) {
            setCanAccept(true);
        }

        el.addEventListener("scroll", onScroll);

        return () => {
            el.removeEventListener("scroll", onScroll);
        };
    }, [show]);

    return (
        <Modal show={show} centered size="lg" backdrop="static" dialogClassName="team-admin-add-member-modal">
            <div className="team-admin-add-member">
                <div ref={scrollContainer} style={{ maxHeight: "50vh", textAlign: "left", overflow: "auto" }} >
                    <LegalComponent
                        title={TermsData.title}
                        lastUpdated={TermsData.lastUpdated}
                        importantNotice={TermsData.importantNotice}
                        sections={TermsData.sections}
                        closingStatement={TermsData.closingStatement}
                    />
                </div>
                <div className="separator mt-5 mb-5"></div>
                <div className="team-admin-add-member__footer">
                    <button type="button" onClick={() => noConfirm?.()} className="tap-add-experience-2-btn-secondary">
                        Decline
                    </button>
                    <button type="button" onClick={() => confirm?.()} className="tap-add-experience-2-btn-main" disabled={!canAccept}>
                        <div className="tap-host-button-text tap-flex-center">
                            Accept and Continue
                            &nbsp;<KTSVG path="/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg" />
                        </div>
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmTermsConditions;